// @flow
import type { Dispatch } from 'redux';
import type { State } from 'app/common/redux/types';

export type LoginModalOpen = { type: 'OPEN_LOGIN_MODAL' };
export type LoginModalClose = { type: 'CLOSE_LOGIN_MODAL' };

export const OpenLoginModal = { type: 'OPEN_LOGIN_MODAL' };
export const CloseLoginModal = { type: 'CLOSE_LOGIN_MODAL' };
export const dispatchOpenLoginModal = (dispatch: Dispatch<any>) => ({
  openLoginModal: () => dispatch(OpenLoginModal),
});

// Typing the return of userIsFullAuth with `| void` due to how $Diff<> works
// https://flow.org/en/docs/react/hoc/#toc-injecting-props-with-a-higher-order-component
export const userIsFullAuth = (state: State): {| isFullAuth: boolean | void |} => ({
  isFullAuth: state.viewer.isAuth && !state.viewer.isLimitedLogin,
});

export default null;
